"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactBootstrap = require("react-bootstrap");

var _QuestionFieldItem = _interopRequireDefault(require("./QuestionFieldItem"));

var _useUseListContext2 = _interopRequireDefault(require("./hooks/useUseListContext"));

var _useMonitorForElements = _interopRequireDefault(require("./hooks/useMonitorForElements"));

var _usePageGroupQuestions = _interopRequireDefault(require("./hooks/usePageGroupQuestions"));

var _useHandleMoveQuestion = _interopRequireDefault(require("./hooks/useHandleMoveQuestion"));

var _useHandleOnDrop = _interopRequireDefault(require("./hooks/useHandleOnDrop"));

var _QuestionsActions = require("../../../redux/Questions/QuestionsActions");

var PageGroupList = function PageGroupList(_ref) {
  var questionList = _ref.questionList,
      reorderQuestions = _ref.reorderQuestions;

  var _usePageGroupQuestion = (0, _usePageGroupQuestions["default"])(questionList),
      items = _usePageGroupQuestion.items,
      getListLength = _usePageGroupQuestion.getListLength;

  var _useUseListContext = (0, _useUseListContext2["default"])(getListLength),
      instanceId = _useUseListContext.instanceId,
      contextValue = _useUseListContext.contextValue,
      ListContext = _useUseListContext.ListContext,
      useListContext = _useUseListContext.useListContext;

  var handleMoveQuestion = (0, _useHandleMoveQuestion["default"])(questionList, reorderQuestions);
  var handleOnDrop = (0, _useHandleOnDrop["default"])(items, handleMoveQuestion);
  (0, _useMonitorForElements["default"])(instanceId, items, handleOnDrop);

  var getIndexOfItem = function getIndexOfItem(item) {
    return items.findIndex(function (i) {
      return i.id === item.id;
    });
  };

  var isMoveDownDisabled = function isMoveDownDisabled(index) {
    return index >= getListLength() - 1;
  };

  var isMoveUpDisabled = function isMoveUpDisabled(index) {
    return index <= 0;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(ListContext.Provider, {
      value: contextValue
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, {
      style: {
        padding: '0'
      }
    }, items.map(function (item) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_QuestionFieldItem["default"], {
          key: item.id,
          item: item,
          index: getIndexOfItem(item),
          useListContext: useListContext,
          onMoveQuestion: handleMoveQuestion,
          disableMoveUp: isMoveUpDisabled(getIndexOfItem(item)),
          disableMoveDown: isMoveDownDisabled(getIndexOfItem(item))
        })
      );
    })))
  );
};

PageGroupList.defaultProps = {
  questionList: []
};
PageGroupList.propTypes = process.env.NODE_ENV !== "production" ? {
  reorderQuestions: _propTypes["default"].func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  questionList: _propTypes["default"].arrayOf(_propTypes["default"].any)
} : {};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    reorderQuestions: function reorderQuestions(questions, lastReorderedQuestionId) {
      return dispatch((0, _QuestionsActions.reorderFormQuestions)(questions, lastReorderedQuestionId));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(PageGroupList);